/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {ProfessionalLicenseService} from './professional-license.service';
import {ControlledSubstancePermitModule} from './permit/controlled-substance-permit.module';

@NgModule({
    imports: [ControlledSubstancePermitModule],
    providers: [
        ProfessionalLicenseService
    ]
})
export class ProfessionalLicenseModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/professional/professional-license.module.ts